import { MapPin, Mail, Instagram } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
  const { content } = useContent();
  const year = new Date().getFullYear();
  const notes = content.houseNotes || [];
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#232E26] text-[#FAF7F2] pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid md:grid-cols-3 gap-10">
        <div>
          <h3 className="font-serif-display text-2xl">Mirabella Anemoessa</h3>
          <p className="mt-3 text-[#EAE0D5]/70 leading-relaxed text-sm">
            A boutique two-bedroom apartment beside the Aegean, in Pefkochori,
            Halkidiki.
          </p>
        </div>
        <div className="text-sm text-[#EAE0D5]/85 space-y-3">
          <p className="overline text-[#EAE0D5]/60">Find us</p>
          <p className="flex items-center gap-2">
            <MapPin size={14} className="text-[#C65D47]" /> Pefkochori,
            Halkidiki, Greece
          </p>
          <p className="flex items-center gap-2">
            <Mail size={14} className="text-[#C65D47]" /> Use the inquiry form
            above
          </p>
          <p className="flex items-center gap-2">
            <Instagram size={14} className="text-[#C65D47]" />{" "}
            @mirabella.anemoessa
          </p>
        </div>
        <div className="text-sm text-[#EAE0D5]/85 space-y-3">
          <p className="overline text-[#EAE0D5]/60">House notes</p>
          {notes.map((n, i) => (
            <p key={i} data-testid={`house-note-${i}`}>
              {n}
            </p>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mt-12 pt-6 border-t border-[#FAF7F2]/10 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[#EAE0D5]/60">
        <p>© {year} Mirabella Anemoessa. All rights reserved.</p>
        <p className="opacity-60">Made with care in Halkidiki</p>
      </div>
    </footer>
  );
}
